'use client';

import { Body, Display } from '@depop/web-thrift-ui/Typography';
import { Button } from '@depop/web-ui-kit/Button';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { Container } from '@/components/Container';
import { ExtendedLink } from '@/components/ExtendedLink';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useSellNowHref } from '@/modules/signup/hooks/useSellNowHref';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function HeroSegment() {
  const WEB_ASSETS_SAFETY_PATH = `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/trustPage/`;
  const t = useTranslations('safety');
  const [, currentUser] = useCurrentUser();
  const { href } = useSellNowHref();
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });

  function handleCtaClick() {
    sendActivityTrackerEvent(ActivityTrackerEventType.CTA_ACTION, {
      type: 'safety_page_cta',
      schemaVersion: '2.0',
    });
  }

  return (
    <section className={styles.section}>
      <Container className={styles.container}>
        <div className={styles.imageContainer}>
          <picture className={styles.heroImage}>
            <source
              type="image/avif"
              media="(min-width: 768px)"
              srcSet={`${WEB_ASSETS_SAFETY_PATH}hero-phone-desktop.avif`}
            />
            <img
              src={`${WEB_ASSETS_SAFETY_PATH}hero-phone-mobile.png`}
              alt="why trust depop"
            />
          </picture>
        </div>
        <div className={styles.textWrapper}>
          <Display>{t('SafetyPage.HeroSegment.Title')}</Display>
          <Body variant="md-regular">
            {t('SafetyPage.HeroSegment.Description')}
          </Body>
          <ExtendedLink
            href={href}
            className={styles.ctaWrapper}
            onClick={handleCtaClick}
          >
            <Button as="span">{t('SafetyPage.StartSellingCTA')}</Button>
          </ExtendedLink>
        </div>
      </Container>
    </section>
  );
}
